import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularSidebar() {
  const topComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
      <div className="flex flex-col lg:flex-row gap-10">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
                编辑推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">精选优质韩漫，不容错过</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
            {comics.filter((c) => c.rating >= 9.5).slice(0, 6).map((comic) => (
              <Link key={comic.id} to={`/article/${comic.id}`} className="block cursor-pointer" data-product-shop="">
                <article className="group">
                  <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      title={`${comic.title} - 韩漫大全推荐`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-background-50 font-medium">
                        推荐
                      </span>
                    </div>
                  </div>
                  <h3 className="font-semibold text-sm text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{comic.description.slice(0, 60)}...</p>
                </article>
              </Link>
            ))}
          </div>
        </div>

        <div className="lg:w-80 shrink-0">
          <div className="sticky top-24">
            <div className="bg-background-100 rounded-2xl p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-5">
                <i className="ri-fire-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                <h3 className="font-semibold text-foreground-800">热门排行</h3>
              </div>
              <ol className="space-y-3">
                {topComics.map((comic, index) => (
                  <li key={comic.id}>
                    <Link
                      to={`/article/${comic.id}`}
                      className="flex items-center gap-3 group cursor-pointer"
                    >
                      <span
                        className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold shrink-0 ${
                          index < 3
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-200 text-foreground-500'
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-foreground-700 font-medium line-clamp-1 group-hover:text-primary-500 transition-colors">
                          {comic.title}
                        </p>
                        <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                      </div>
                      <span className="text-xs text-accent-500 font-medium shrink-0 whitespace-nowrap">
                        {comic.rating} 分
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}